import { useRoot } from './RootProvider';

export function useFabric() {
  return useRoot().fabric;
}
